import {createAuthUrl} from "../../config/rootEpic";
import {apiUrl} from "../../components/common/getEnv";

export const loginUrl = () => createAuthUrl("/iam/v1/auth/token");
export const refreshTokenUrl = () => loginUrl();
export const checkSessionUrl = () => `${apiUrl}/session`;